module.exports = __webpack_public_path__ + "img/search.c4fe42d7.svg";